import React from "react";
import { Box } from "@mui/material";

export const SERIES = {
  hired: "hsl(142, 71%, 45%)",
  applied: "hsl(217, 91%, 55%)",
  you: "hsl(150, 38%, 17%)",
  team: "hsl(140, 8%, 68%)",
};

export const FUNNEL_COLORS = [
  "hsl(217, 91%, 55%)",
  "hsl(175, 60%, 45%)",
  "hsl(142, 71%, 45%)",
  "hsl(150, 45%, 30%)",
  "hsl(150, 38%, 17%)",
];

export const OUTCOME_LABELS = {
  not_contacted: "Not contacted",
  no_answer: "No answer",
  voicemail: "Voicemail",
  not_interested: "Not interested",
  signed_up: "Signed up",
  follow_up_today: "Callback",
  follow_up_later: "Callback",
  to_be_checked: "To be checked",
  applied: "Applied",
  sign_up_later: "Sign up later",
  email_sent: "Email sent",
};

export const OUTCOME_COLORS = {
  signed_up: "hsl(142, 71%, 45%)",
  applied: "hsl(150, 38%, 17%)",
  follow_up_today: "hsl(217, 91%, 55%)",
  follow_up_later: "hsl(217, 91%, 55%)",
  sign_up_later: "hsl(262, 65%, 55%)",
  no_answer: "hsl(0, 72%, 51%)",
  voicemail: "hsl(38, 92%, 50%)",
  not_interested: "hsl(150, 10%, 46%)",
  to_be_checked: "hsl(150, 10%, 60%)",
  not_contacted: "hsl(150, 8%, 75%)",
  email_sent: "hsl(217, 91%, 55%)",
};

export const ChartTooltip = ({ active, payload, label, suffix = "" }) => {
  if (!active || !payload?.length) return null;
  return (
    <Box sx={{ backgroundColor: "hsl(150, 30%, 12%)", borderRadius: "8px", px: 1.5, py: 1 }}>
      {(label || payload[0]?.name) && (
        <Box sx={{ fontSize: 11, color: "hsl(150, 10%, 70%)", mb: 0.5, fontFamily: "Segoe UI Regular, sans-serif, system-ui" }}>
          {label ?? payload[0]?.name}
        </Box>
      )}
      {payload.map((entry, i) => (
        <Box key={i} sx={{ display: "flex", alignItems: "center", gap: 0.75, fontSize: 12.5, fontFamily: "Segoe UI Semibold, sans-serif, system-ui", color: "#fff" }}>
          <Box sx={{ width: 8, height: 8, borderRadius: "2px", backgroundColor: entry.color || entry.payload?.color || "#fff" }} />
          {entry.name ? `${entry.name}: ` : ""}
          {entry.value?.toLocaleString()}{suffix}
        </Box>
      ))}
    </Box>
  );
};
